<template src="./index.html"></template>
<script>
	import minhead from '../../../../common/minHead/index.vue';
	import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue';
	import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue';
	import {
		getdata
	} from './data.js';
	import config from '../../../../../../configHttp.js';
	import uploadFile from '../../../../common/uploadFile/index.vue';
	import uploadFileplus from '../../../../common/uploadFileplus/index.vue';
	import {
		querycell,
		writesave,
		startShenBao,
		forShengcdg,
		manuscriptqueryReportStep,
		manuscriptwriteimport,
		manuscriptUploadFile,
		annexadd,
		findConpanyConfig
	} from '../../../../../api/Draftgeneration.js';
	import {
		querytemplatecell,
		getShuibDetailList,
		templatecellsave
	} from '../../../../../api/bbmb.js';
	import {
		reportquerytrack
	} from '../../../../../api/xggj.js';
	import {
		zcfg_fycx,
		zcfg_fetch
	} from '../../../../../api/zcfg.js';
	import addzc from '../../../../common/addzc/index.vue';
	import seezc from '../../../../common/seezc/index.vue';
	import DisabilityPayment_I from './DisabilityPayment_I/index.vue';
	import {
		getdata as getdataI
	} from './DisabilityPayment_I/data.js';
	export default {
		name: '',
		components: {
			minhead,
			SalesTaxReportTree,
			SalesTaxReportbox,
			uploadFile,
			uploadFileplus,
			addzc,
			seezc,
			DisabilityPayment_I
		},
		props: {
			type: {
				type: String,
				default: ''
			},
			params: {
				type: Object,
				default: {}
			},
			suosq: {
				type: String,
				default: ''
			},
			showbox: {
				type: Boolean,
				default: false
			},
			mintext: {
				type: String,
				default: '填写'
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			seeNow: {
				type: Boolean,
				default: false
			}
		},
		async mounted() {
			// let tiem = await this.timeUpdata()
			if (this.toseeUpdate) {
				this.getShuibDetailList();
			} else if (!this.toseeUpdate) {
				this.manuscriptqueryReportStep();
			}
		},
		data: function() {
			return {
				treestate: '',
				statedata: [],
				treedata: getdata().treedata,
				choosetitleindex: '',
				formlist: getdata().formlist,
				headobj: {},
				choosecellCode: '',
				smtext: '',
				zcdata: [],
				searchlistzc: getdata().searchlistzc,
				headDatazc: getdata().headDatazc,
				pagination: getdata().pagination,
				seezcformlist: getdata().seezcformlist,
				formdatazc: getdata().formdatazc, //form表单数据
				//表一
				tableDataI_I: [],
				tableDataI_II: {},
				IHead: [
					'cbj_0_x_1',
					'cbj_0_x_2',
					'cbj_0_x_3',
					'cbj_0_x_4',
					'cbj_0_x_5',
					'cbj_0_x_6',
					'cbj_0_x_7',
					'cbj_0_x_8',
					'cbj_0_x_9',
					'cbj_0_x_10',
					'cbj_0_x_10a',
					'cbj_0_x_11',
					'cbj_0_x_12',
					'cbj_0_x_13'
				],
				//表三
				choosetable: '',
				chooseindex: '',
				choosecolum: '',
				delCellsI: [],
				start: '',
				stop: '',
			};
		},

		methods: {
			//政策点击预览
			zcsclick(id) {
				this.$refs.boxref.zcsclick(id);
			},
			//选中格子
			forhover(table, colum, index) {
				this.$refs.boxref.forhover(table, colum, index);
			},
			//获取选中格子
			getchoosecellCode(table, colum, index) {
				if (this.$emptyandnull(table)) {
					this.choosecellCode = '';
					return false;
				}
				this.choosetable = table;
				this.chooseindex = index;
				this.choosecolum = colum;

				this.choosecellCode = this[table][index][colum].cellCode;
				if (this.toseeUpdate) {
					this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : '';
					this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : [];
				} else {
					this.smtext = this[table][index][colum]['updateDesc'] || '';
				}
			},
			//更正说明
			forgengzheng(table, colum, index, smtext) {
				this[table][index][colum]['updateDesc'] = smtext;
			},
			//更正政策和说明
			forxzsm(table, colum, index, smtext, zcdata) {
				this[table][index][colum]['map'] = {
					desc: '',
					zcs: []
				};
				this[table][index][colum]['map']['desc'] = smtext;
				this[table][index][colum]['map']['zcs'] = zcdata;
			},
			//点击全部范围
			refreshhover() {
				this.$nextTick(() => {
					this.$refs.boxref.refreshhover();
				});
			},
			getShuibDetailList() {
				getShuibDetailList({
					shuizId: this.params.shuizId,
					id: this.params.shuibId
				}).then(res => {
					if (res.data.code == 1) {
						this.treedata = res.data.data;
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0]);
						}
						this.querycell();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			manuscriptqueryReportStep() {
				manuscriptqueryReportStep({
					id: this.params.id,
					sbbm: this.params.sbbm
				}).then(res => {
					if (res.data.code == 1) {
						this.statedata = res.data.data.statusHistory;
						this.treedata = res.data.data.detail;
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0]);
						}
						this.querycell();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			getchoosetitleindex(item) {
				this.choosetitleindex = item.shuibNameCode;
			},
			//表格隐藏显示和返回
			forback() {
				this.$emit('forback', true);
			},
			changestate(e) {
				this.treestate = e;
			},
			//传给后端值处理
			filternums(data, filterlist) {
				var newlist = [];
				filterlist.forEach(ytem => {
					let newval = data.map(item => {
						if (item[ytem] != undefined && item[ytem] != 'undefined' && this.$notemptyandnull(
								item[ytem]) && item[ytem].cellVal != '合计') {
							return item[ytem];
						} else {
							return 'x';
						}
					});
					newlist = [...newlist, ...newval].filter(gtem => gtem != 'x');
				});
				return newlist;
			},

			refreshtableDataI() {
				this.tableDataI_I.forEach((item, index) => {
					this.IHead.forEach(gtem => {

						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -' && gtem != 'cbj_0_x_2' && gtem != 'cbj_0_x_3') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},

			commanddcrefresh(e) {
				if (e == 'all') {
					Object.keys(this.headobj).map(key => (this.headobj[key] = ''));
					this.refreshtableDataI();
				}
			},
			headchange(e) {
				this.headobj = e
			},
			//所有表格渲染
			querycell(index) {

				if (this.type == 'update') {
					querycell({
						companyNo: this.params.companyNo, // 公司编号
						id: this.params.id, //报表id
						shuibId: this.params.shuibId, //税种id
						sbbm: this.params.sbbm
					}).then(res => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
				}
				if (this.type == 'tosee') {
					if (this.seeNow) {
						querycell({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm
						}).then(res => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
						return false;
					}
					if (this.toseeUpdate) {
						querytemplatecell({
							shuibId: this.params.shuibId,
							id: this.params.id
						}).then(res => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
					} else {
						reportquerytrack({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm,
							trackId: this.params.trackId
						}).then(res => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
					}
				}
			},
			async timeUpdata() {
				let params = {
					companyNo: this.params.companyNo,
					shuibId: this.params.shuibId,
					suosq: this.suosq
				}
				findConpanyConfig(params).then(res => {
					if (res.data.code == 1) {
						this.start = res.data.head.shuikssqq
						this.stop = res.data.data.head.shuikssqz
						return true
					} else {
						this.$message.error(res.data.msg)
					}
				})

			},
			gettable(dataarr) {
				this.headobj = dataarr.head;
				let time = new Date()
				// substring
				dataarr.cbj_0.forEach(item => {
					if (item.cbj_0_x_1) {
						if (item.cbj_0_x_1.cellVal == '' || item.cbj_0_x_1.cellVal == null) {
							item.cbj_0_x_1.cellVal = 1
						}
					}
					if (item.cbj_0_x_2) {
						if (item.cbj_0_x_2.cellVal == '' || item.cbj_0_x_2.cellVal == null) {
							item.cbj_0_x_2.cellVal = this.headobj .shuikssqq
						}
					}
					if (item.cbj_0_x_3) {
						if (item.cbj_0_x_3.cellVal == '' || item.cbj_0_x_3.cellVal == null) {
							item.cbj_0_x_3.cellVal = this.headobj .shuikssqz
						}
					}
					if (item.cbj_0_x_6) {
						if ((item.cbj_0_x_6.cellVal == '' || item.cbj_0_x_6.cellVal == null)) {
							if (item.cbj_0_x_6.cellCode == 'cbj_0_1000_6') {
								item.cbj_0_x_6.cellVal = "- -"
							} else {
								item.cbj_0_x_6.cellVal = '1.5'
							}
						} else {
							if (item.cbj_0_x_6.cellCode == 'cbj_0_1000_6') {
								item.cbj_0_x_6.cellVal = "- -"
							} else {
								item.cbj_0_x_6.cellVal = `${item.cbj_0_x_6.cellVal*100}`
							}
						}
					}

				})
				this.tableDataI_I = dataarr.cbj_0;

			},
			IdelCellsCode(e) {
				this.delCellsI = [...this.filternums(e, this.IHead)];
			},
			forsave() {
				const newarr = [...this.filternums(this.tableDataI_I, this.IHead)];
				newarr.forEach(item => {
					let code = item.cellCode.substring(item.cellCode.length - 2, item.cellCode.length - 1) == "_" ?
						item.cellCode.substring(item.cellCode.length - 1, item.cellCode.length) : item.cellCode
						.substring(item.cellCode.length - 2, item.cellCode.length - 1)
					if (code == "6") {
						if (item.cellCode != 'cbj_0_1000_6') {
							item.cellVal = item.cellVal * 0.01
						}
					}
				})
				let params = {
					cells: newarr,
					companyNo: this.params.companyNo,
					delCells: this.delCellsI,
					id: this.params.id,
					sbbm: this.params.sbbm,
					head: this.headobj,
					checkFlag: 'true'
				};
				writesave(params).then(res => {
					if (res.data.code == 1) {
						this.Changed = 0
						this.querycell();
						this.$message.success(res.data.msg);
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			inputblur(e) {
				this.Changed++
				if ((parseFloat(e.cellVal).toFixed(2) != parseFloat(this[this.choosetable][this.chooseindex][this
						.choosecolum
					]['cellOldVal']).toFixed(2)) && this[this.choosetable][this.chooseindex][this.choosecolum][
						'cellCode'
					] == e.cellCode) {
					this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = "1"
				}
				let code = e.cellCode.substring(e.cellCode.length - 2, e.cellCode.length - 1) == "_" ? e.cellCode
					.substring(e.cellCode.length - 1, e.cellCode.length) : e.cellCode.substring(e.cellCode.length - 2, e
						.cellCode.length)
				let num = e.cellCode.substring(e.cellCode.length - code.length - 3, e.cellCode.length - code.length - 2) ==
					'_' ? e.cellCode.substring(e.cellCode.length - code.length - 2, e.cellCode.length - code.length - 1) :
					e.cellCode.substring(e.cellCode.length - code.length - 3, e.cellCode.length - code.length - 2)
				if (code == "4") {
					this.changetableval(`cbj_0_${num}_8`, 'tableDataI_I', this.gettableval(`cbj_0_${num}_4`,
							'tableDataI_I') /
						this.gettableval(`cbj_0_${num}_5`, 'tableDataI_I'))
				}
				if (code == "5") {
					this.changetableval(`cbj_0_${num}_8`, 'tableDataI_I', this.gettableval(`cbj_0_${num}_4`,
							'tableDataI_I') /
						this.gettableval(`cbj_0_${num}_5`, 'tableDataI_I'))
					if ((this.gettableval(`cbj_0_${num}_5`, 'tableDataI_I') * (this.gettableval(`cbj_0_${num}_6`,
								'tableDataI_I') * 0.01) -
							this.gettableval(`cbj_0_${num}_7`, 'tableDataI_I')) * this.gettableval(`cbj_0_${num}_8`,
							'tableDataI_I') > 0) {
						this.changetableval(`cbj_0_${num}_9`, 'tableDataI_I', (this.gettableval(`cbj_0_${num}_5`,
									'tableDataI_I') *
								(this.gettableval(`cbj_0_${num}_6`, 'tableDataI_I') * 0.01) - this.gettableval(
									`cbj_0_${num}_7`, 'tableDataI_I')) *
							this.gettableval(`cbj_0_${num}_8`, 'tableDataI_I'), null, 4)
					} else {
						this.changetableval(`cbj_0_${num}_9`, 'tableDataI_I', 0)
					}
				}
				if (code == "6") {
					if ((this.gettableval(`cbj_0_${num}_5`, 'tableDataI_I') * (this.gettableval(`cbj_0_${num}_6`,
								'tableDataI_I') * 0.01) -
							this.gettableval(`cbj_0_${num}_7`, 'tableDataI_I')) * this.gettableval(`cbj_0_${num}_8`,
							'tableDataI_I') > 0) {
						this.changetableval(`cbj_0_${num}_9`, 'tableDataI_I', (this.gettableval(`cbj_0_${num}_5`,
									'tableDataI_I') *
								(this.gettableval(`cbj_0_${num}_6`, 'tableDataI_I') * 0.01) - this.gettableval(
									`cbj_0_${num}_7`, 'tableDataI_I')) *
							this.gettableval(`cbj_0_${num}_8`, 'tableDataI_I'), null, 4)
					} else {
						this.changetableval(`cbj_0_${num}_9`, 'tableDataI_I', 0)
					}
				}
				if (code == "7") {
					if ((this.gettableval(`cbj_0_${num}_5`, 'tableDataI_I') * (this.gettableval(`cbj_0_${num}_6`,
								'tableDataI_I') * 0.01) -
							this.gettableval(`cbj_0_${num}_7`, 'tableDataI_I')) * this.gettableval(`cbj_0_${num}_8`,
							'tableDataI_I') > 0) {
						this.changetableval(`cbj_0_${num}_9`, 'tableDataI_I', (this.gettableval(`cbj_0_${num}_5`,
									'tableDataI_I') *
								(this.gettableval(`cbj_0_${num}_6`, 'tableDataI_I') * 0.01) - this.gettableval(
									`cbj_0_${num}_7`, 'tableDataI_I')) *
							this.gettableval(`cbj_0_${num}_8`, 'tableDataI_I'), null, 4)
					} else {
						this.changetableval(`cbj_0_${num}_9`, 'tableDataI_I', 0)
					}
				}
				if (code == "8") {
					if ((this.gettableval(`cbj_0_${num}_5`, 'tableDataI_I') * (this.gettableval(`cbj_0_${num}_6`,
								'tableDataI_I') * 0.01) -
							this.gettableval(`cbj_0_${num}_7`, 'tableDataI_I')) * this.gettableval(`cbj_0_${num}_8`,
							'tableDataI_I') > 0) {
						this.changetableval(`cbj_0_${num}_9`, 'tableDataI_I', (this.gettableval(`cbj_0_${num}_5`,
									'tableDataI_I') *
								(this.gettableval(`cbj_0_${num}_6`, 'tableDataI_I') * 0.01) - this.gettableval(
									`cbj_0_${num}_7`, 'tableDataI_I')) *
							this.gettableval(`cbj_0_${num}_8`, 'tableDataI_I'), null, 4)
					} else {
						this.changetableval(`cbj_0_${num}_9`, 'tableDataI_I', 0)
					}
					this.cbj_0_1000_8(code, num)
				}
				if (code == "9") {
					this.changetableval(`cbj_0_${num}_13`, 'tableDataI_I', this.gettableval(`cbj_0_${num}_9`,
							'tableDataI_I') -
						this.gettableval(`cbj_0_${num}_11`, 'tableDataI_I') - this.gettableval(`cbj_0_${num}_12`,
							'tableDataI_I'))
					this.cbj_0_1000_9()
				}
				if (code == "11") {
					this.changetableval(`cbj_0_${num}_13`, 'tableDataI_I', this.gettableval(`cbj_0_${num}_9`,
							'tableDataI_I') -
						this.gettableval(`cbj_0_${num}_11`, 'tableDataI_I') - this.gettableval(`cbj_0_${num}_12`,
							'tableDataI_I'))
				}
				if (code == "12") {
					this.changetableval(`cbj_0_${num}_13`, 'tableDataI_I', this.gettableval(`cbj_0_${num}_9`,
							'tableDataI_I') -
						this.gettableval(`cbj_0_${num}_11`, 'tableDataI_I') - this.gettableval(`cbj_0_${num}_12`,
							'tableDataI_I'))
				}
				if (code == "13") {
					this.cbj_0_1000_13()
				}
			},
			cbj_0_1000_8(code, num) {
				let total = 0
				this.tableDataI_I.map(item => {
					Object.keys(item).map(key => {
						let Code = key.substring(key.length - 2, key.length - 1) == "_" ? key.substring(key
							.length - 1, key.length) : key.substring(key.length - 2, key.length - 1)
						if (Code == 8 && item[key].cellCode != 'cbj_0_1000_8') {
							total += this.gettableval(`${item[key].cellCode}`, 'tableDataI_I')
						}
					})
				})
				this.changetableval(`cbj_0_1000_8`, 'tableDataI_I', total)
			},
			cbj_0_1000_9(code, num) {
				let total = 0
				this.tableDataI_I.map(item => {
					Object.keys(item).map(key => {
						let Code = key.substring(key.length - 2, key.length - 1) == "_" ? key.substring(key
							.length - 1, key.length) : key.substring(key.length - 2, key.length - 1)
						if (Code == 9 && item[key].cellCode != 'cbj_0_1000_9') {
							total += this.gettableval(`${item[key].cellCode}`, 'tableDataI_I')
						}
					})
				})
				this.changetableval(`cbj_0_1000_9`, 'tableDataI_I', total)
			},
			cbj_0_1000_13() {
				let total = 0
				this.tableDataI_I.map(item => {
					Object.keys(item).map(key => {
						let Code = key.substring(key.length - 2, key.length - 1) == "_" ? key.substring(key
							.length - 1, key.length) : key.substring(key.length - 2, key.length)
						if (Code == 13 && item[key].cellCode != 'cbj_0_1000_13') {
							total += this.gettableval(`${item[key].cellCode}`, 'tableDataI_I')
						}
					})
				})
				this.changetableval(`cbj_0_1000_13`, 'tableDataI_I', total)
			},
			gettableval(changecode, table, old) {
				var head = '';
				if (table == 'tableDataI_I') {
					head = 'IHead';
				}
				if (table == 'tableDataIII' || table == 'tableDatavx') {
					head = 'IIIHead';
				}
				var a;
				if (this[table] && this[head]) {
					for (let i = 0; i < this[table].length; i++) {
						for (let j = 0; j < this[head].length; j++) {
							if (
								this[table][i][this[head][j]] &&
								this[table][i][this[head][j]].cellCode &&
								this[table][i][this[head][j]].cellVal &&
								this[table][i][this[head][j]].cellCode == changecode
							) {
								if (old) {
									if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
										a = 0;
									} else {
										a = parseFloat(this[table][i][this[head][j]].goujgxValue);
									}
								} else {
									if (this[table][i][this[head][j]].cellVal == '-') {
										a = 0;
									} else {
										a = parseFloat(this[table][i][this[head][j]].cellVal || 0);
									}
								}
								break;
							}
						}
					}
				}
				a = a || 0;
				if (changecode == 'sdsA_1_18_1' || changecode == 'sdsA_1_19_1' || changecode == 'sdsA_1_20_1' ||
					changecode == 'sdsA_1_20_2' || changecode == 'sdsA_1_23.2_2') {
					if (!a < 1) {
						a = a * 0.01;
					}
				}
				return a;
			},
			changetableval(changecode, table, newval, checkq) {
				var newval = newval || 0
				if (checkq) {
					newval = this.toFixed(newval, checkq)
				} else {
					newval = this.toFixed(newval, 2)
				}
				var head = '';
				if (table == 'tableDataI_I') {
					head = 'IHead';
				}
				if (table == 'tableDataIII' || table == 'tableDatavx') {
					head = 'IIIHead';
				}
				for (let i = 0; i < this[table].length; i++) {
					for (let j = 0; j < this[head].length; j++) {
						if (
							this[table][i][this[head][j]] &&
							this[table][i][this[head][j]].cellCode &&
							typeof this[table][i][this[head][j]].cellVal != 'undefined' &&
							typeof this[table][i][this[head][j]].cellVal != undefined &&
							this[table][i][this[head][j]].cellCode == changecode
						) {
							if (this[table][i][this[head][j]].cellVal != newval) {
								this[table][i][this[head][j]].cellVal = newval + '';
								this.inputblur({
									cellCode: changecode,
									cellVal: newval
								});
								break;
							}
						}
					}
				}
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>